<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" style="height: 130px">
    </parallax>
    <div class="main main-raised">
      <div class="section section-basic">
        <div class="container" style="min-height: 500px">
          <div class="contentBox">
            <!-- <el-card style="max-height:340px">
              <Leftbar></Leftbar>
            </el-card> -->
            <el-card class="rightContent">
              <h3>
                {{ $t("profile.profile") }}
                <span style="float: right">
                  <el-button
                    type="primary"
                    @click="editPersonForm('personInfoForm')"
                    >{{ $t("profile.editProfile") }}</el-button
                  >
                </span>
              </h3>
              <el-divider></el-divider>
              <el-form
                :model="personInfoForm"
                ref="personInfoForm"
                label-width="140px"
                class="demo-personInfoForm"
              >
                <el-form-item :label="$t('profile.name')" prop="name">
                  {{ personInfoForm.name }}
                </el-form-item>
                <el-form-item :label="$t('profile.identity')" prop="identity">
                  {{
                    personInfoForm.identity == 3
                      ? $t("profile.student")
                      : $t("profile.teacher")
                  }}
                </el-form-item>
                <el-form-item
                  v-if="personInfoForm.identity == 3"
                  :label="$t('profile.stuNumber')"
                  prop="studentNumber"
                >
                  {{ personInfoForm.studentNumber }}
                </el-form-item>
                <el-form-item :label="$t('profile.tel')" prop="mobile">
                  {{ personInfoForm.mobile }}
                </el-form-item>
                <el-form-item
                  :label="$t('profile.email')"
                  prop="email"
                  :class="{ warning_text: !personInfoForm.email }"
                >
                  {{ personInfoForm.email || $t("profile.toAdd") }}
                </el-form-item>
                <el-form-item
                  :label="$t('profile.location')"
                  prop="province"
                  :class="{ warning_text: !personInfoForm.province }"
                >
                  {{ province || $t("profile.toAdd") }}
                  <!--                  <span v-if="!personInfoForm.province">$t('profile.toAdd')</span>-->
                  <!--                  <span v-else>-->
                  <!--                    <span v-if="$i18n.locale==='cn'">{{ personInfoForm.province  }}</span>-->
                  <!--                    <span v-if="$i18n.locale==='en'">{{ personInfoForm.province | toEnLocation }}</span>-->
                  <!--                  </span>-->
                </el-form-item>
                <el-form-item
                  :label="$t('profile.school')"
                  prop="school"
                  :class="{ warning_text: !personInfoForm.school }"
                >
                  {{ personInfoForm.school || $t("profile.toAdd") }}
                </el-form-item>
                <el-form-item
                  v-if="personInfoForm.identity == 3"
                  :label="$t('profile.mentor')"
                  prop="teacher"
                  :class="{ warning_text: !personInfoForm.teacher_name }"
                >
                  {{ personInfoForm.teacher_name || $t("profile.toAdd") }}
                </el-form-item>
                <el-form-item
                  v-if="personInfoForm.identity == 3"
                  :label="$t('profile.mentor_email')"
                  prop="teacher_email"
                  :class="{ warning_text: !personInfoForm.teacher_email }"
                >
                  {{ personInfoForm.teacher_email || $t("profile.toAdd") }}
                </el-form-item>
                <el-form-item :label="$t('profile.attachment')" prop="photoUrl">
                  <a :href="personInfoForm.photoUrl">{{
                    $t("common.clickForMore")
                  }}</a>
                </el-form-item>
              </el-form>
            </el-card>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Leftbar from "../../components/newComponent/Leftbar";
import { userInfoGet } from "../../api/user";
import {
  taskTypeFilter,
  taskStateFilter,
  taskBadgeFilter,
} from "../../utils/filter";

import { location } from "../../../public/location.js";

export default {
  components: {
    Leftbar,
  },
  name: "profile",
  bodyClass: "index-page",
  props: {},
  filters: {
    taskTypeFilter,
    taskStateFilter,
    taskBadgeFilter,
  },
  data() {
    return {
      firstname: null,
      email: null,
      password: null,
      taskKeyword: "",
      personInfoForm: {
        name: "",
        identity: 0,
        mobile: "",
        email: "",
        studentNumber: "", // todo 没有studentid
        teacher: "", // todo 没有老师email
        file: "",
      },
      fileList: [],
    };
  },
  mounted() {
    this.initUserInfo();
  },
  methods: {
    editPersonForm() {
      this.$router.push("/profile/edit");
    },
    // },
    initUserInfo() {
      userInfoGet(localStorage.getItem("uid")).then((res) => {
        this.personInfoForm = res;
        localStorage.setItem("user", JSON.stringify(res));
      });
    },
  },
  computed: {
    signupImage() {
      return {
        backgroundImage: `url(${this.signup})`,
      };
    },
    province() {
      if (this.$i18n.locale === "en") {
        const { province } = this.personInfoForm;
        for (const key of location) {
          if (key.label_cn === province) {
            return key.label_en;
          }
        }
      }
      return this.personInfoForm.province;
    },
  },
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
</style>

<style scoped>
.userServices {
  /* position: absolute; */
  text-align: center;
  height: 50px;
  line-height: 50px;
}
.warning_text {
  color: red;
}
</style>
